module.exports = __webpack_public_path__ + "img/icon.48dba6b6.png";